import { clsx } from 'clsx';
import { AnimatePresence, motion } from 'motion/react';
import type { PropsWithChildren } from 'react';
import { Flex } from '../Flex/Flex';
import { Layout } from '../Layout/Layout';
import { Spinner } from '../Spinner/Spinner';
import * as styles from './LinkButton.css';
import type { LinkButtonVariants } from './LinkButton.css';

export type LinkButtonProps = LinkButtonVariants &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onAnimationStart' | 'onDrag' | 'onDragEnd' | 'onDragStart'> & {
    readonly loading?: boolean;
    readonly disabled?: boolean;
    readonly layout?: boolean | 'position';
  };

const loadingVariants = {
  true: { opacity: 0 },
  false: { opacity: 1 },
};

export const LinkButton: React.FC<PropsWithChildren<LinkButtonProps>> = ({
  children,
  disabled = false,
  loading = false,
  variant,
  className: externalClassName,
  layout = false,
  ...props
}) => {
  return (
    <Layout
      as={motion.button}
      className={clsx(styles.linkButton({ variant, loading }), externalClassName)}
      disabled={disabled || loading}
      layout={layout}
      position="relative"
      type="button"
      {...props}
    >
      <Flex animate={loading.toString()} as={motion.div} variants={loadingVariants}>
        {children}
      </Flex>
      <AnimatePresence>
        {loading && (
          <Layout
            animate={(!loading).toString()}
            as={motion.div}
            className={styles.linkButtonSpinner}
            variants={loadingVariants}
          >
            <Spinner size="sm" />
          </Layout>
        )}
      </AnimatePresence>
    </Layout>
  );
};
